module.exports = __webpack_public_path__ + "media/base/circle_ok-3f3ffaab.svg";